import React, { useState, useEffect, useRef } from "react";
import "./CarouselStyle.css";

const Carousel = ({ images, interval, zoom }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [translateValue, setTranslateValue] = useState(0);
  const carouselRef = useRef(null);
  const infiniteImages = images.concat(images);

  const handleImageClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const slideWidth = carouselRef.current.clientWidth / images.length;
    const timer = setInterval(() => {
      if (currentIndex === infiniteImages.length - 1) {
        setCurrentIndex(0);
        setTranslateValue(0);
      } else {
        setCurrentIndex(currentIndex + 1);
        setTranslateValue(translateValue - slideWidth);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [
    currentIndex,
    images.length,
    infiniteImages.length,
    interval,
    translateValue,
  ]);

  return (
    <div className="carousel-container">
      <div
        className="carousel-slides"
        style={{ transform: `translateX(${translateValue}px)` }}
        ref={carouselRef}
      >
        {infiniteImages.map((image, index) => (
          <img
            key={index}
            src={image}
            className={`carousel-slide ${
              currentIndex === index ? "active" : ""
            } ${zoom ? "zoomable" : ""}`}
            onClick={() => handleImageClick(index)}
            alt="different images in carousel"
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
